module.exports = __webpack_public_path__ + "static/media/scrambler-ducati-yellow-bike.31fb0dfb.jpeg";